<ncp-table #surgicalProcedures [(options)]="options"></ncp-table>
